import { render } from "./SortTableFiltersComponent.vue?vue&type=template&id=2b8523d0&scoped=true"
import script from "./SortTableFiltersComponent.vue?vue&type=script&lang=js"
export * from "./SortTableFiltersComponent.vue?vue&type=script&lang=js"

import "./SortTableFiltersComponent.vue?vue&type=style&index=0&id=2b8523d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8523d0"]])

export default __exports__